import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { ref, reactive, onMounted, toRefs } from "vue";
import { getCurrentInstance } from "vue";
import apis from "@/api";
import { deleteNoticeById } from "../../api/modules/Notice";
import { defineComponent } from "vue";
export default {
  components: {},
  name: "TagSetting",
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      queryParam: {
        noticeName: "",
        status: "",
        startTime: "",
        endTime: ""
      },
      title: "新增/编辑标签",
      messageTag: "",
      visible: false,
      publisherHidden: true,
      popupForm: {
        id: "",
        tagName: "",
        parNum: "",
        tagNum: "",
        createTime: "",
        updateTime: ""
      },
      statusOption: [{
        value: "1",
        label: "在线"
      }, {
        value: "0",
        label: "已下线"
      }],
      rulesValue: {
        tagName: [{
          required: true,
          message: "标签名称不能为空!",
          trigger: "change"
        }],
        tagNum: [{
          required: true,
          message: "标签编码不能为空!",
          trigger: "change"
        }]
      },
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      allData: [],
      treeData: [],
      show: true,
      dateShow: true,
      updateShow: true,
      idShow: false,
      tagNumber: "",
      columns: [],
      total: 0,
      currentPage: 1,
      searchFlag: false
    });
    const loadData = () => {
      apis.queryTagTree2(data.queryParam).then(res => {
        data.treeData = res.data;
      });
    };
    const resetForm = form => {
      proxy.$refs[form].resetFields();
    };
    const submitForm = form => {
      proxy.$refs[form].validate(valid => {
        if (valid) {
          data.searchFlag = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    const sizeChange = pageSize => {
      this.pageSize = pageSize;
      this.currentChange(this.currentPage);
    };
    const currentChange = currentPage => {
      console.log("currentPage:", currentPage);
      if (data.searchFlag) {
        apis.listNotice({
          pageNo: currentPage,
          pageSize: data.pageSize,
          empName: data.queryParam.empName
        }).then(res => {
          console.log("current:records->", res);
          data.tableData = res.records;
        });
      } else {
        apis.listNotice({
          pageNo: currentPage,
          pageSize: data.pageSize
        }).then(res => {
          console.log("current:records->", res);
          data.tableData = res.records;
        });
      }
    };
    const addUser = () => {};
    onMounted(() => {
      console.log("初始化查询开始------------");
      loadData();
    });
    //显示弹窗
    const popupShow = (str, row) => {
      data.title = str.toString();
      data.visible = true;
      if (str === "新增顶级父标签") {
        data.show = false;
        data.updateShow = false;
      }
      //如果是编辑，就会有原始数据
      if (str === "新增子标签") {
        data.show = true;
        data.popupForm.parNum = row.tagNum;
        data.updateShow = false;

        /*
                     id: "",
                    tagName: "",
                    parNum: "",
                    tagNum: "",
                    createTime: "",
                    updateTime: "",
                    * */
      }
      if (str === "编辑标签") {
        data.show = true;
        data.idShow = true;
        data.dateShow = false;
        data.popupForm.id = row.id;
        data.popupForm.tagName = row.tagName;
        data.popupForm.parNum = row.parNum;
        data.popupForm.tagNum = row.tagNum;
        data.popupForm.endTime = row.endTime;
        data.tagNumber = row.tagNum;
      }
    };

    //取消、重置弹窗
    const popupCancel = formName => {
      /*  proxy.$refs[formName].resetFields();*/
      data.visible = false;
      setTimeout(() => {
        resetFields(formName);
      }, 300);
    };
    const resetFields = formName => {
      data.show = true;
      data.dateShow = true;
      data.updateShow = true;
      data.idShow = false;
      data.popupForm.id = "";
      data.popupForm.tagName = "";
      data.popupForm.parNum = "";
      data.popupForm.tagNum = "";
      data.popupForm.endTime = "";
      data.tagNumber = "";
      data.messageTag = "";
    };

    //提交数据
    const popupCommit = formName => {
      //form数据校验

      let tagEntity = {
        id: "",
        tagName: "",
        parNum: "",
        tagNum: "",
        createTime: "",
        updateTime: ""
      };
      if (true) {
        if (data.title === "新增顶级父标签") {
          tagEntity.tagName = data.popupForm.tagName;
          tagEntity.parNum = "";
          tagEntity.tagNum = data.popupForm.tagNum;
          doAddTag(tagEntity, formName);
        } else if (data.title === "新增子标签") {
          tagEntity.tagName = data.popupForm.tagName;
          tagEntity.parNum = data.popupForm.parNum;
          tagEntity.tagNum = data.popupForm.tagNum;
          doAddTag(tagEntity, formName);
        } else {
          tagEntity.tagNum = data.popupForm.tagNum;
          if (tagEntity.tagNum === data.tagNumber) {
            //如果相同，则说明没有改过标签的编号
            tagEntity.id = data.popupForm.id;
            tagEntity.tagName = data.popupForm.tagName;
            updateTag(tagEntity, formName);
          } else {
            //不相同
            tagEntity.tagNum = data.popupForm.tagNum + "," + data.tagNumber;
            tagEntity.id = data.popupForm.id;
            tagEntity.tagName = data.popupForm.tagName;
            updateTagTree(tagEntity, formName);
          }
        }
      } else {
        console.log("提交失败!");
        return false;
      }
    };

    //新增标签
    const doAddTag = (par, formName) => {
      apis.addTag(par).then(res => {
        console.log(res);
        if (res.success) {
          open("添加标签成功！");
          popupCancel(formName);
          loadData();
        } else {
          close("错了哦，新增标签失败！");
        }
      });
    };

    //修改标签
    const updateTag = (par, formName) => {
      apis.updateTag(par).then(res => {
        if (res.success) {
          open("修改标签成功！");
          popupCancel(formName);
          loadData();
        } else {
          close("错了哦，修改标签失败！");
        }
      });
    };

    //修改标签
    const updateTagTree = (par, formName) => {
      apis.updateTagTree(par).then(res => {
        if (res.success) {
          open("修改标签成功！");
          popupCancel(formName);
          loadData();
        } else {
          close("错了哦，修改标签失败！");
        }
      });
    };

    /*删除标签*/
    const doDeleteTag = row => {
      apis.deleteTag({
        id: row.id
      }).then(res => {
        if (res.success) {
          open("删除标签成功！");
          loadData();
        } else {
          close("错了哦，删除标签失败！");
        }
      });
    };
    const open = (str, row) => {
      ElMessage.success({
        message: str,
        type: "success"
      });
    };
    const close = (str, row) => {
      ElMessage.error(str);
    };

    //时间格式化
    const dateFormat = dateTime => {
      function addDateZero(num) {
        return num < 10 ? "0" + num : num;
      }
      let d = new Date(dateTime);
      let formatDatetime = d.getFullYear() + "-" + addDateZero(d.getMonth() + 1) + "-" + addDateZero(d.getDate()) + " " + addDateZero(d.getHours()) + ":" + addDateZero(d.getMinutes()) + ":" + addDateZero(d.getSeconds());
      return formatDatetime;
    };

    //判断时间字符串中是否有字母
    const hasLetter = str => {
      let regString = /[a-zA-Z]+/;
      if (str) {
        return regString.test(str);
      }
    };
    return {
      ...toRefs(data),
      proxy,
      loadData,
      resetForm,
      submitForm,
      currentChange,
      sizeChange,
      popupShow,
      popupCancel,
      popupCommit,
      doAddTag,
      dateFormat,
      hasLetter,
      doDeleteTag,
      resetFields,
      updateTagTree,
      open,
      close
    };
  }
};